module.exports = __webpack_public_path__ + "h5/img/zhanshi.aadd048d.png";